import React, { FunctionComponent, useEffect } from 'react';
import styles from './Shortlist.module.scss';
import { ExpertImage } from 'assets/user/index';
import InfoCard from './InfoCard';
import { useGetFavoritesQuery, useGetBackofficeUserFavoritesQuery } from 'services/exploreApi';
import { UserState } from 'features/user/userSlice';
import { SessionState } from 'features/session/sessionSlice';
import { Program, School } from 'app/types';
import { useAppSelector } from 'app/hooks';
import FavoriteCard from './FavoriteCard';
import { SchoolFavoriteCard } from './FavoriteCard';
import { useLocation } from 'react-router-dom';
import Skeletons from 'common/components/Skeletons/Skeletons';

const Shorlist: FunctionComponent = () => {
  const location = useLocation();
  let programs;
  let favorites;
  let schools;
  let refetch: any;
  let isProgramsLoading: any;
  let isSchoolsLoading: any;
  const isBackoffice = location.pathname.includes('backoffice');
  if (isBackoffice) {
    const { user } = useAppSelector(({ session }: { session: SessionState }) => session);
    ({ data: programs, refetch } = useGetBackofficeUserFavoritesQuery(user?.id || 1));
    ({ data: schools, refetch } = useGetFavoritesQuery('School'));
  } else {
    ({ data: programs, isLoading: isProgramsLoading, refetch } = useGetFavoritesQuery('Program'));
    ({ data: schools, isLoading: isSchoolsLoading, refetch } = useGetFavoritesQuery('School'));
    ({ favorites } = useAppSelector(({ user }: { user: UserState }) => user));
  }

  useEffect(() => {
    if (!isBackoffice) {
      refetch();
    }
  }, [favorites]);
  return (
    <div className={styles.shorlistContainer}>
      <h1 className={styles.title}>Shortlist</h1>
      <div className="d-flex flex-column gap-4">
        <div className="d-flex gap-4 row">
          <InfoCard
            title="Request a Custom Shortlist"
            description="Request a bespoke school list for your future studies"
            buttonText="Request Now"
            mainImg={ExpertImage}
            alt="Icon of a suitup guy watching a screen"
          />
          <InfoCard
            title="School Match"
            description="Fill your preferences and get recommended schools for you"
            buttonText="Try Now"
            mainImg={ExpertImage}
            alt="Icon of women moving buttons on a screen"
          />
        </div>
        {isProgramsLoading || isSchoolsLoading ? (
          <Skeletons />
        ) : (
          <div
            className={`row flex-row mt-3 pt-1 justify-content-center justify-content-xl-start gap-4`}
          >
            {programs?.data.map((program: Program | School) => (
              <FavoriteCard program={program as Program} key={program.id} />
            ))}
            {schools?.data.map((school: Program | School) => (
              <SchoolFavoriteCard school={school as School} key={school.id} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Shorlist;
